document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-flipdown]").forEach((el) => {
        const isoDate = el.getAttribute("data-date");
        const variant = el.getAttribute("variant");
        const endDate = new Date(isoDate);
        const timeFromNow = endDate.getTime() / 1000;

        if (endDate.getTime() - Date.now() < 259200000) {
            el.classList.add("late");
        }

        new FlipDown(timeFromNow, el.id, {
            theme: variant,
            headings: ["dnů", "hodin", "minut", "sekund"],
        })
            .start()
            .ifEnded(() => {
                console.log(`Countdown ended: ${el.id}`);
            });
    });
});

/* Run only when "isHpPage" is true */
if (document.querySelectorAll(".js-page-hp").length > 0) {
    // Floating button START
    var elements = document.querySelectorAll("[class^=vyzva-button]");
    var floating = document.getElementById("floatingButton");
    function checkVisible(elm) {
        var viewHeight = Math.max(
            document.documentElement.clientHeight,
            window.innerHeight,
        );
        var visibility = [];
        elm.forEach((element) => {
            var rect = element.getBoundingClientRect();
            visibility.push(!(rect.bottom < 0 || rect.top - viewHeight >= 0));
        });
        return visibility.includes(true);
    }

    window.onscroll = function () {
        floating.style.display = checkVisible(elements) ? "none" : "block";
    };
    // Floating button END
}

//START Copy
function copyClipboard($input_name) {
    var value = document.querySelector(
        "input[name=cv_" + $input_name + "",
    ).value;
    if (navigator.clipboard) {
        navigator.clipboard.writeText(value);
    }

    console.log("copied: " + value);
}
window.copyClipboard = copyClipboard;

function showCopySuccess(el) {
    console.log("here");
    var elem = document.getElementsByClassName("copy-success");
    elem.length > 0 ? elem[0].remove() : ""; //.forEach((i, index)=> i.spice(index,1)):"";
    el.appendChild(document.createElement("span")).classList.add(
        "copy-success",
    );

    var notice = document.getElementsByClassName("copy-success")[0];

    notice.innerText = "zkopírováno";

    setTimeout(function () {
        notice.remove();
    }, 2000);
}
window.showCopySuccess = showCopySuccess;
//END Copy

// popups START
window.addEventListener("DOMContentLoaded", function () {
    // Helper functions
    function lockScroll() {
        document.body.style.overflow = "hidden";
    }

    function unlockScrollIfNoPopups() {
        // Odemkni scroll jen pokud není žádný otevřený popup
        if (document.querySelectorAll(".js-popup-shown").length === 0) {
            document.body.style.overflow = "";
        }
    }

    // Otevře popup podle jména
    function openPopupByName(name) {
        console.log("openPopupByName", name);

        const popupEl = document.querySelector(`*[data-popupname="${name}"]`);

        if (popupEl) {
            const parent = popupEl.parentElement;
            parent.classList.remove("inactive-modal");

            const closerBackground = parent.querySelector(
                ".js-popups-closer-background",
            );
            if (closerBackground) {
                closerBackground.style.display = "block";
                closerBackground.style.opacity = "0";
                setTimeout(() => {
                    closerBackground.style.opacity = "1";
                    closerBackground.style.transition = "opacity 0.3s";
                }, 10);
            }

            popupEl.classList.add("js-popup-shown");
            popupEl.style.display = "block";
            popupEl.style.opacity = "0";
            setTimeout(() => {
                popupEl.style.opacity = "1";
                popupEl.style.transition = "opacity 0.3s";
            }, 10);

            lockScroll();
        }
    }
    window.openPopupByName = openPopupByName;

    // Close popup element
    function closePopupElement(popupEl) {
        if (!popupEl) return;

        const parent = popupEl.parentElement;

        // Fade out background
        const closerBackground = parent.querySelector(
            ".js-popups-closer-background",
        );
        if (closerBackground) {
            closerBackground.style.opacity = "0";
            closerBackground.addEventListener(
                "transitionend",
                () => {
                    closerBackground.style.display = "none";
                    parent.classList.add("inactive-modal");
                },
                { once: true },
            );
        }

        // Fade out popup content
        popupEl.style.opacity = "0";
        popupEl.addEventListener(
            "transitionend",
            () => {
                popupEl.style.display = "none";
                popupEl.classList.remove("js-popup-shown");
                unlockScrollIfNoPopups();
            },
            { once: true },
        );
    }
    // Close popup triggered by click on .js-popup-close
    document.addEventListener("click", (event) => {
        const closeTarget = event.target.closest(".js-popup-close");
        if (closeTarget) {
            let popupEl = closeTarget.closest("[data-popupname]");
            if (!popupEl) {
                popupEl =
                    closeTarget.parentElement.querySelector("[data-popupname]");
            }
            closePopupElement(popupEl);
        }
    });

    // Trigger opening popups
    function addOnClickToPopupTriggers() {
        const popupTriggers = document.querySelectorAll(".js-popup-trigger");

        popupTriggers.forEach((trigger) => {
            trigger.onclick = function () {
                const popupName = trigger.getAttribute("data-popupshow");
                openPopupByName(popupName);
            };
        });
    }
    addOnClickToPopupTriggers();

    document.addEventListener("click", function (e) {
        const target = e.target.closest(".js-popup-trigger");
        if (target) {
            const popupName = target.getAttribute("data-popupshow");
            openPopupByName(popupName);
        }
    });
});
// popups END

// check dimensions of the viewport START
if (document.querySelector("[data-start-checking-dimensions]")) {
    var checkDimensions = function checkDimensions() {
        // Kontrola, zda je aktivním prvkem (focusem) element <input>
        var activeElement = document.activeElement;
        var isInputFocused =
            activeElement && activeElement.tagName.toLowerCase() === "input";

        if (isInputFocused) {
            document.documentElement.style.setProperty("--app-height", "100vh");
        } else {
            document.documentElement.style.setProperty(
                "--app-height",
                window.innerHeight + "px",
            );
        }
    };

    console.log("startCheckingDimensions");
    checkDimensions();

    /* Interval pro kontrolu rozměrů každých 500ms
  setInterval(function () {
    checkDimensions();
  }, 500);*/
    window.addEventListener("resize", checkDimensions);
}
// check dimensions of the viewport END

/* =========================
   DONATE RANGE SLIDER
========================= */

if (document.querySelector(".js-page-donate")) {
    const donationForm = document.getElementById("donationForm");

    const rangeLine = document.querySelector(".range-line");
    const activeLine = document.querySelector(".range-active-line");
    const rangeThumbnail = document.querySelector(".range-thumbnail");
    const baitThumbnail = document.querySelector(".bait-thumbnail");

    let rangeWidth = rangeLine.offsetWidth;
    let thumbWidth = baitThumbnail.offsetWidth;

    let thumbPercent = 0;
    let thumbVisualPosition = 0;

    let defaultAmountIndex = parseInt(
        donationForm.dataset.defaultAmountIndex || 0,
    );

    let percent = [0, 15.714, 38.571, 51.428, 68, 95];

    if (window.innerWidth < 768) {
        percent = [0, 15.714, 38.571, 51.428, 68, 91];
    }

    if (window.innerWidth < 500) {
        percent = [0, 15.714, 38.571, 51.428, 68, 93];
    }

    if (window.innerWidth < 300) {
        percent = [0, 15.714, 38.571, 51.428, 68, 90];
    }

    let currPercent = percent[defaultAmountIndex];

    let isDragging = false;

    /* =========================
       EVENTS
    ========================= */

    baitThumbnail.addEventListener("pointerdown", () => {
        isDragging = true;
        window.thumbnailActive = true;
    });

    document.addEventListener("pointermove", (e) => {
        if (!isDragging) return;

        const rect = rangeLine.getBoundingClientRect();

        let x = e.clientX - rect.left;

        x = Math.max(0, Math.min(x, rangeWidth - thumbWidth));

        baitThumbnail.style.left = `${x}px`;

        updateThumbStatus(x, false);
    });

    document.addEventListener("pointerup", () => {
        if (!isDragging) return;

        isDragging = false;
        window.thumbnailActive = false;

        setTimeout(() => {
            changeLoc();
        }, 100);
    });

    rangeLine.addEventListener("click", (e) => {
        const rect = rangeLine.getBoundingClientRect();

        const xPos = e.clientX - rect.left;

        updateThumbStatus(xPos, false);

        setTimeout(() => {
            changeLoc();
        }, 100);
    });

    window.addEventListener("resize", () => {
        rangeWidth = rangeLine.offsetWidth;
        thumbWidth = baitThumbnail.offsetWidth;
        changeLoc();
    });

    /* =========================
       FUNCTIONS
    ========================= */

    function updateThumbStatus(input, state) {
        let currentThumbPos = 0;

        if (state === false) {
            currentThumbPos = parseInt(input);
        } else {
            currentThumbPos = parseInt(window.getComputedStyle(input).left);
        }

        thumbPercent = currentThumbPos / ((rangeWidth - thumbWidth) / 100);

        thumbVisualPosition = currentThumbPos / (rangeWidth / 100);

        stepJump(thumbPercent);
    }

    function stepJump(input) {
        let activeIndex = 0;

        for (let i = 0; i < percent.length; ++i) {
            if (percent[i] <= input) {
                activeIndex = i;
            }
        }

        // clamp na plný rozsah (NE -2 !!!)
        activeIndex = Math.max(0, Math.min(activeIndex, percent.length - 1));

        const value = percent[activeIndex];

        rangeThumbnail.style.left = value + "%";
        activeLine.style.width = (value + 5) + "%";

        currPercent = value;

        setStep(activeIndex);
    }

    function changeLoc() {
        baitThumbnail.style.left = `${currPercent}%`;
    }

   function setStep(step) {
      const component = document.getElementById('donationForm');

      if (!component || !window.Alpine) return;

      const data = Alpine.$data(component);

      // bezpečný step
      const safeStep = Math.max(0, Math.min(step, percent.length - 1));

      if (typeof data.setStep === 'function') {
          data.setStep(safeStep);
      }

      // 🔥 KLÍČ: amount nikdy mimo rozsah
      const amount = parseInt(data.amount);

      data.amount = Math.min(
          isNaN(amount) ? 0 : amount,
          2050
      );
  }

    /* =========================
       INIT
    ========================= */

    changeLoc();
    updateThumbStatus(baitThumbnail, true);
}
